export const StaticImagePreview = ({
  label,
  summary_entry_id
}) => {
  return <div className="static-image--field non-input-label-wrapper">
      <label className="non-input-label">{label}</label>
      {summary_entry_id && <>
          <img src="/images/gif/Static Image.png" alt={`An image of ${label}`} />
          <div className="tooltip--disclaimer--container">
            <div className="tooltip--disclaimer">
              This is a placeholder image. The image you selected will appear on
              your mobile device.
            </div>
          </div>
        </>}
    </div>;
};